
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";


import LoginToManageYourEvent from "./loginToManageYourEvent";
import LoggedInUserContent from "./loggedInUserContent";
import { useParams } from "react-router-dom";

import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { loginWithTokenKey } from "../../../store/auth/event/action";
import LoadingSpinner from "../../../Components/Common/Spinner";
// Task 24837 - shared guest-page styling, defined next to the sign-up page.
import "../RegisterGuestToEvent/registerGuestToEvent.styles.css";

const OrganisersEventPage = () => {
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    dispatch(loginWithTokenKey("", params?.token));
  }, [params?.token]);

  const { loginWithTokenKeyDataAPI, loginWithTokenKeyLoading } = useSelector(
    (state) => ({
      loginWithTokenKeyDataAPI: state.EventReducer.loginWithTokenKeyData,
      loginWithTokenKeyLoading: state.EventReducer.loginWithTokenKeyLoading,
    })
  );

  const [eventUserLoggedIn, setEventUserLoggedIn] = useState(false);
  const [eventUserRole, setEventUserRole] = useState("");
  const [eventUserData, setEventUserData] = useState([]);
  const [branding, setBranding] = useState({});
  useEffect(() => {
    if (isEmpty(loginWithTokenKeyDataAPI)) return;
    if (loginWithTokenKeyDataAPI?.status === 200) {
      setEventUserLoggedIn(true);
      setEventUserRole(loginWithTokenKeyDataAPI?.MasterTokenKeyType_Id);
      setEventUserData(loginWithTokenKeyDataAPI);
      setBranding(loginWithTokenKeyDataAPI?.branding);
    } else {
      toast.error(loginWithTokenKeyDataAPI?.message);
    }
  }, [loginWithTokenKeyDataAPI]);
  // Task 24837 - the shell now matches the sign-up page: one centred card on
  // the venue's own background, and no magic numbers.
  //
  // What went: marginTop -30px pulling the page up under the chrome,
  // paddingTop 50px putting it back, and a marginTop of 230px on the login
  // card - a number that can only have been right on one screen. The
  // ParticlesAuth frame went with them; it is the old Velzon particle
  // background, which the rest of the product stopped using for public pages.
  return (
    <div
      className="guest-page"
      style={{ background: branding?.PortalCssColourPageBackground }}
    >
      {loginWithTokenKeyLoading ? (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ minHeight: "60vh" }}
        >
          <LoadingSpinner title={"Loading event…"} size={"medium"} />
        </div>
      ) : eventUserLoggedIn ? (
        <div className="guest-card guest-card--wide">
          <div className="guest-card__body">
            <LoggedInUserContent
              eventUserRole={eventUserRole}
              eventUserData={eventUserData}
              branding={branding}
            />
          </div>
        </div>
      ) : (
        <div className="guest-card">
          <div
            className="guest-card__header"
            style={{ background: branding?.PortalCssColourDivBackground }}
          >
            {branding?.LogoUrl && (
              <img
                src={branding.LogoUrl}
                alt="logo"
                className="guest-card__logo"
              />
            )}
          </div>
          <div className="guest-card__body">
            <h2 className="guest-title">Your event</h2>
            <p className="guest-subtitle mb-4">
              Confirm who you are to see the details and choose your food.
            </p>
            <LoginToManageYourEvent
              eventUserLoggedIn={eventUserLoggedIn}
              setEventUserLoggedIn={setEventUserLoggedIn}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default OrganisersEventPage;
